import SeoTitle from '@/components/SeoTitle';
import PageJsonLd from './components/PageJsonLd';
import Navbar from '@/components/feature/Navbar';
import HeroSection from './components/HeroSection';
import ClusterNavigation from './components/ClusterNavigation';
import ManagementSkills from './components/ManagementSkills';
import SpecialistToManager from './components/SpecialistToManager';
import WhenNeededSection from './components/WhenNeededSection';
import TargetAudienceSection from './components/TargetAudienceSection';
import FormatsSection from './components/FormatsSection';
import ProcessSection from './components/ProcessSection';
import WhyProgramsWorkSection from './components/WhyProgramsWorkSection';
import CompanyResultsSection from './components/CompanyResultsSection';
import AboutTrainerSection from './components/AboutTrainerSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import StudyFurtherSection from './components/StudyFurtherSection';
import RoiCtaStrip from '@/components/feature/RoiCtaStrip';
import Footer from '@/components/feature/Footer';

const hubNavLinks = [
  { label: 'Программы', target: 'cluster' },
  { label: 'Навыки', target: 'skills' },
  { label: 'Процесс', target: 'process' },
  { label: 'FAQ', target: 'faq' },
];

export default function ManagementHubPage() {
  return (
    <>
      
      <SeoTitle title="Менеджмент и лидерство | Business Training" />
      <PageJsonLd />

      <div className="min-h-screen bg-white font-['Inter']">
        <Navbar
          links={hubNavLinks}
          ctaLabel="Заказать тренинг"
          ctaTarget="contact"
        />
        <HeroSection />

        <div id="cluster">
          <ClusterNavigation />
        </div>

        <div id="skills">
          <ManagementSkills />
        </div>

        <SpecialistToManager />
        <WhenNeededSection />
        <TargetAudienceSection />
        <FormatsSection />

        <div id="process">
          <ProcessSection />
        </div>

        <WhyProgramsWorkSection />
        <CompanyResultsSection />
        <AboutTrainerSection />
        <FAQSection />
        <CTASection />
        <StudyFurtherSection />
        <RoiCtaStrip />
        <Footer />
      </div>
    </>
  );
}